import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import Groups from "../components/structureComponent/groupsComponent";

export default function GroupsPage() {
    return (
        <Layout>
            <Header/>
            <Groups/>
            <Footer/>
        </Layout>
    );
}
